import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Http from "../../../../commons/utils/Http";
import AccountTable from "../../../../commons/components/AccountTable";
import ButtonAction from "../../../../commons/components/buttonAction";
import TagApplicationRoles from "../../../../commons/components/TagApplicationRoles";
import GeneralModal from "../GeneralModal/generalModal";

import { TableActions } from './cardGeneralStyles';

import {
    usersSetSelectedGeneralPartner,
    usersSetModeGeneralModal,
    usersSetShowGeneralModal,
} from '../../../../store/actions/usersActions';

import generalModalModes from "../GeneralModal/generalModalModes";

import Permissions from "../../../../commons/utils/permissions";

function CardGeneral(props) {
    const { screens } = useSelector(state => state.userLogin);
    const { selectedUser, showGeneralModal } = useSelector((state) => state.users);
    const dispatch = useDispatch();

    const [permissions] = useState([]);

    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(true);

    const [lineExpand, setLineExpand] = useState(null);

    const tableColumns = [
        {
            render: (text, record, index) => (
                <div>Permissões gerais</div>
            ),
        },
        {
            title: 'Aplicações',
            dataIndex: 'applications',
            key: 'applications',
            render: (text, record, index) => (
                <TagApplicationRoles
                    data={text}
                    expand={record.id === lineExpand ? true : false} />
            ),
        },
        {
            title: 'Ação',
            key: 'action',
            width: '10%',
            ellipsis: true,
            align: "center",
            render: (text, record, index) => (
                <TableActions>
                    <ButtonAction type={record.id === lineExpand ? "view-focused" : "view"} text="Visualizar" callback={() => handleViewPermissions(record)} />
                    {(permissions.find(_function => _function.function_id === Permissions.EDITAR_PERMISSOES_GERAIS)) ?
                        <ButtonAction type="edit" text="Editar Permissões" callback={() => handleEditPartner(record)} />
                        : null
                    }

                </TableActions>
            ),
        }
    ];

    useEffect(() => {
        getGeneralPermissions();
    }, []);

    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/users") {
                    screen.functions.map(_function => {
                        if (!permissions.find(permission => permission.function_id == _function.function_id)) {
                            permissions.push(_function);
                        }
                    })
                }
            });
        }
    }, [screens]);

    function getGeneralPermissions() {
        setTableLoading(true);
        Http.get(`/users/get-general-permissions?user_id=${selectedUser.id}`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    setTableData(responseData.data);
                    setTableLoading(false);
                }
            }).catch(err => {
                setTableLoading(false);
            })
    }

    function handleViewPermissions(partner) {
        partner.id !== lineExpand ? setLineExpand(partner.id) : setLineExpand(null);
    }

    function handleEditPartner(partner) {
        dispatch(usersSetModeGeneralModal(generalModalModes.EDIT));
        dispatch(usersSetShowGeneralModal(true));
        dispatch(usersSetSelectedGeneralPartner(partner));
    };

    function handleOnSave() {
        getGeneralPermissions();
    }

    return (
        <>
            <AccountTable
                columns={tableColumns}
                dataSource={tableData}
                loading={tableLoading}
                unsetRowHover={true}
                pagination={false}
            />
            {showGeneralModal ? <GeneralModal onSave={handleOnSave} /> : null}
        </>
    )
}

export default CardGeneral;
